import React from 'react';
import { Progress } from 'antd';
import { useLanguage } from '../../contexts/LanguageContext';
import styles from './CardDownloadOverlay.module.scss';

interface CardDownloadOverlayProps {
  percent: number;
}

const CardDownloadOverlay: React.FC<CardDownloadOverlayProps> = ({ percent }) => {
  const { t } = useLanguage();

  return (
    <div className={styles.overlay} aria-live="polite" aria-busy="true">
      <span className={styles.label}>{t('downloadProgress.downloading')}</span>
      <Progress
        percent={percent}
        size="small"
        showInfo
        className={styles.progress}
        strokeColor="var(--app-accent-color, #00c271)"
      />
    </div>
  );
};

export default CardDownloadOverlay;
